export default __webpack_public_path__ + "static/ellipse_right-c84fc83798e7bf9ad9ac71f10c617c26.png";